




















import { Component, Prop, Mixins } from "vue-property-decorator";
import { Rectangle, Point } from "../../domain/drawing";
import { LocatableMixin, RectangleLayoutableMixin, LinearLayoutableMixin } from "./mixins";

@Component({
})
export default class Locator extends Mixins(LocatableMixin, RectangleLayoutableMixin, LinearLayoutableMixin) {
  @Prop()
  zIndex: number;

  get rootStyle(): any {
    return {
      zIndex: this.zIndex,
    };
  }

  get isVisible(): boolean {
    return this.isLocating
      || this.isRectangleLayouting
      || this.isLinearLayouting;
  }

  async locateVertically(rectangle: Rectangle): Promise<Point> {
    return this._locateVertically(rectangle);
  }

  cancel(): void {
    this.cancelLocating();
    this.cancelRectangleLayouting();
    this.cancelLinearLayouting();
  }
}
